import { Select, SelectOption, ToolbarFilter } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { useLocations } from '@app/domain/visit/visit.hooks'

import { FilterCategories, FilterLabels } from './filters'

interface Props {
  location: string
  showToolbarItem: boolean
  onLocationUpdated: (location?: string) => void
}

export const LocationToolbarFilter = ({
  location,
  onLocationUpdated,
  showToolbarItem,
}: Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)

  const { getLocations, locations } = useLocations()

  const locationMenuItems = useMemo(() => {
    return locations?.map((location) => {
      return <SelectOption key={location} value={location} />
    })
  }, [locations])

  const onSelect = useCallback(
    (event: React.MouseEvent | React.ChangeEvent) => {
      if (event.target instanceof HTMLButtonElement) {
        onLocationUpdated(event.target.innerText)
      }
    },
    [onLocationUpdated],
  )

  const onToggle = useCallback((isOpen: boolean) => {
    setIsDropdownOpen(isOpen)
  }, [])

  const onDelete = useCallback(() => {
    onLocationUpdated(null)
  }, [onLocationUpdated])

  const locationChips = useMemo(() => {
    return location ? [location] : []
  }, [location])

  useEffect(() => {
    getLocations()
  }, [getLocations])

  return (
    <ToolbarFilter
      chips={locationChips}
      deleteChip={onDelete}
      categoryName={FilterLabels[FilterCategories.Location]}
      showToolbarItem={showToolbarItem}
    >
      <Select
        aria-label={FilterLabels[FilterCategories.Location]}
        onToggle={onToggle}
        onSelect={onSelect}
        selections={location}
        isOpen={isDropdownOpen}
        placeholderText="Any"
      >
        {locationMenuItems}
      </Select>
    </ToolbarFilter>
  )
}
